import { styled } from '@mui/material/styles';
import Container from 'components/Container';
import DownloadApp from 'pages/DownloadApp';
import LocationQR from 'pages/LocationQR';
import Callback from 'pages/login/Callback';
import { ChangePassword } from 'pages/login/ChangePassword';
import { CompleteOnMobile } from 'pages/login/CompleteOnMobile';
import Evernorth from 'pages/login/Evernorth';
import { LoginNonSSO } from 'pages/login/LoginNonSSO';
import Start from 'pages/login/Start';
import RedirectQR from 'pages/RedirectQR';
import React from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
  RouterProvider,
} from 'react-router';
import { DOWNLOAD_APP_PATH } from 'utils/appStore';
import { mobileOnlyDeepLinks } from 'utils/deeplinks';

const GuestBrowserRouter = () => {
  /*
    NOTE: after add a new route, make sure to add it
    to the .pa11yci.js file to be included in the accessibility tests
  */
  const routesConfig = createRoutesFromElements(
    <Route>
      <Route path="/pepsico" element={<Evernorth />} />
      <Route path="/location/:locationId" element={<LocationQR />} />
      <Route path={DOWNLOAD_APP_PATH} element={<DownloadApp />} />
      <Route
        element={
          <GuestLayout>
            <AuthenticationContainer>
              <Outlet />
            </AuthenticationContainer>
          </GuestLayout>
        }
      >
        <Route path="/" element={<Start />} />
        <Route path="/start/:email/:clientId?" element={<Start />} />
        <Route path="/login" element={<LoginNonSSO />} />
        <Route path="/complete-on-mobile" element={<CompleteOnMobile />} />
        <Route path="/callback" element={<Callback />} />
        <Route path="/forgot-password" element={<ChangePassword />} />
        <Route
          path="/password-expired"
          element={
            <ChangePassword message="Your password has expired. Please create a new password." />
          }
        />
        {/* Redirect To App */}
        {mobileOnlyDeepLinks.map((link) => (
          <Route path={link} key={link} element={<RedirectQR />} />
        ))}
        <Route path="*" element={<Start />} />
      </Route>
    </Route>,
  );

  return createBrowserRouter(routesConfig);
};

const App = () => <RouterProvider router={GuestBrowserRouter()} />;

export default App;

const GuestLayout = styled('div')({
  display: 'flex',
  flex: 1,
});

const AuthenticationContainer = styled(Container)({
  display: 'flex',
  flex: 1,
});
